<template>
    <Breadcrumbs :list="breadcrumpsList"/>
    <div class="main-card mb-3 card">
        <div class="card-body">
            <ml-form
                    :dataForm="formData"
                    :struct="formStruct"
                    @submittedForm="sendValue"
                    @canceledForm="cancelForm"
                    @changeValue="changeValue"
            />


        </div>
    </div>
</template>



<script>
    import Breadcrumbs from '@miro-labs/vue3-architect-layout/layout/base/Breadcrumbs.vue'
    import Form from '../../../form/ml/form/From.vue'
    import {updateValue} from '../../../form/ml/form/class/InputsManager'

    export default {

        components: {
            Breadcrumbs,
            'ml-form': Form
        },


        data() {

            const breadcrumpsList = [
                {label: "Strona główna", routerName: 'mainPage', params: {}, query: {}},
                {label: "CMS", routerName: 'cmsGalleryFolderList', params: {}, query: {}},
                {label: "Oferta", routerName: 'offerList', params: {}, query: {}},
                {label: "Edycja"}
            ];

            return {
                roles: [],
                formData: {
                    name: '',
                    description: '',
                    active: false
                },
                formStruct: {fields: []},
                breadcrumpsList

            }
        },


        methods: {
            async changeValue(data) {
                updateValue(this.formData, data);
            },

            async sendValue(data) {
                data.resources = data.resources ? data.resources
                        .map(r => {
                            return {resource: r, deleted: false};
                        }) : [];

                data.attributes.forEach(a => {
                    if (!a.property) {
                        a.property = {name: ''};
                    }
                    a.property.name = a.name;
                });

                await this.$store.dispatch('offer/saveOffer', data);
                this.$router.replace({name: 'offerList'});

            },
            cancelForm() {
                this.$router.replace({name: 'offerList'});
            }

        },

        async beforeMount() {
            let url = process.env.VUE_APP_API_HOST + '/api/cms/resources';
            let token = await this.$store.dispatch("api/getTicket");
            if (this.$route.params.id) {
                this.formData = await this.$store.dispatch('offer/findOffer', this.$route.params.id);
                this.formData.resources = this.formData.resources ?  this.formData.resources.map( r => r.resource) : [];
            } else {
                this.formData = {
                    title: '',
                    externalLink: '',
                    description: '',
                    category: '',
                    groupName: '',
                    price: null,
                    priceBeforeDiscount: null,
                    resources: [],
                    attributes: [],
                }
            }

            this.formData.attributes.forEach(a => a.name = a.property ? a.property.name : '');
            this.formData.added = new Date(this.formData.added);

            this.formStruct = {
                rebuild: true,
                fields: [
                    {type: 'TEXT', name: 'title', label: 'Tytuł', placeholder: 'Wpisz tytuł',
                        tooltip: 'Wpisz tytuł', info: '',
                        required: true,  requiredMessage: 'Pole jest wymagane',
                        maxLength: 200, maxLengthMessage: 'Pole może mieć maksymalnie 200 znaków'},
                    {type: 'TEXT', name: 'externalLink', label: 'Link', placeholder: 'Wpisz link',
                        tooltip: 'Link zewnętrzny do oferty', info: '',
                        maxLength: 255, maxLengthMessage: 'Pole może mieć maksymalnie 255 znaków'},
                    {type: 'NUMBER', name: 'price', label: 'Cena', placeholder: 'Wpisz cenę',
                        tooltip: 'Wpisz cenę', info: '',
                        required: true,  requiredMessage: 'Pole jest wymagane',
                        minFractionDigits: 2, maxFractionDigits: 2, locale: 'pl'},
                    {type: 'TEXT', name: 'category', label: 'Kategoria', placeholder: 'Wpisz kategorię',
                        tooltip: 'Wpisz kategorię', info: '',
                        maxLength: 200, maxLengthMessage: 'Pole może mieć maksymalnie 200 znaków'},
                    {type: 'TEXT', name: 'groupName', label: 'Nazwa grupy', placeholder: 'Wpisz grupe',
                        tooltip: 'Wpisz grupę', info: '',
                        maxLength: 200, maxLengthMessage: 'Pole może mieć maksymalnie 200 znaków'},
                    {type: 'NUMBER', name: 'priceBeforeDiscount', label: 'Cena przed promocją', placeholder: 'Wpisz cenę',
                        tooltip: 'Wpisz cenę', info: '',
                        required: false,
                        minFractionDigits: 2, maxFractionDigits: 2, locale: 'pl'},
                    {type: 'CALENDAR', name: 'added', label: 'Data oferty', tooltip: 'Data publikacji', info: '', showTime: true},
                    {type: 'TEXTAREA', name: 'description', label: 'Opis skrócony', placeholder: 'Wpisz opis',
                        tooltip: 'Wpisz opis', info: '',
                        required: true,  requiredMessage: 'Pole jest wymagane',
                        maxLength: 800, maxLengthMessage: 'Pole może mieć maksymalnie 800 znaków'},
                    {type: 'EDITOR', name: 'content', label: 'Treść',
                        info: '', required: true},
                    {type: 'EDIT_TABLE', name: 'attributes', label: 'Atrybuty',
                        columns: [
                            {name: 'name', header: 'Nazwa', type: 'text', style: 'width: auto'},
                            {name: 'value', header: 'Wartość', type: 'text', style: 'width: auto'},
                        ],
                        addLabel: 'Dodaj atrybut',
                        addMethod: () => { return {id: null, property: {name: ''}, value: ''}},
                        filterMethod: () => true,
                        removeMethod: () => null,
                    },


                    {type: 'FILE_UPLOAD', name: 'resources', label: 'Zdjęcie', token: token,
                        url: url, multiple: false,
                        info: '', required: false, fileLimit: 10},


                ],
                cancelValue: 'Anuluj',
                submitValue: 'Zapisz'
            };

        }
    }

</script>